export const EDITOR_SHAPE_TEMP_ID_PREFIX = 'temp_';
export var LineStyle;
(function (LineStyle) {
    LineStyle["Solid"] = "solid";
    LineStyle["Dashed"] = "dashed";
})(LineStyle || (LineStyle = {}));
